/**
* 头部菜单
*/
<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff"
      active-text-color="#fff">
      <el-button class="buttonimg">
        <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
      </el-button>
      <el-submenu index="2" class="submenu">
        <template slot="title">{{$store.state.username}}</template>
        <el-menu-item @click="handlePwd()" index="2-2">更改密码</el-menu-item>
        <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
      </el-submenu>
    </el-menu>
    <!-- 修改密码 -->
    <el-dialog title="修改密码" :visible.sync="resetFormVisible" width="30%" @click='closeDialog()'>
      <el-form label-width="80px" ref="resetpwd" :model="resetpwd" :rules="resetpwdRules">
        <el-form-item label="新密码" prop="password">
          <el-input size="small" v-model="resetpwd.password" maxlength="16" show-password auto-complete="off"
            placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="repassword">
          <el-input size="small" v-model="resetpwd.repassword" maxlength="16" show-password auto-complete="off"
            placeholder="请确认密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog()'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="chooseResetpwd('resetpwd')">保存
        </el-button>
      </div>
    </el-dialog>
  </div>

</template>
<script>
  // 导入请求方法
  import {
    userPwd,
  } from '../api/userMG'
  export default {
    name: 'navcon',
    data() {
      return {
        loading: false, //是显示加载
        resetFormVisible: false, //控制修改密码显示与隐藏
        // 重置密码表单验证
        resetpwdRules: {
          password: [
            { required: true, message: '请输入新密码', trigger: 'blur' }
          ],
          repassword: [
            { required: true, message: '请确认密码', trigger: 'blur' }
          ],
        },
        // 重置密码
        resetpwd: {
          password: '',
          repassword: ''
        },
        collapsed: true,
        imgshow: require('../assets/img/show.png'),
        imgsq: require('../assets/img/sq.png'),
        user: {}
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.user = JSON.parse(localStorage.getItem('userdata'))
    },
    methods: {
      // 退出登录
      exit() {
        this.$confirm('退出登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            setTimeout(() => {
              this.$store.commit('logout', 'false')
              this.$router.push({ path: '/login' })
              this.$message({
                type: 'success',
                message: '已退出登录!'
              })
            }, 1000)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      // 切换显示
      toggle(showtype) {
        this.collapsed = !showtype
        this.$root.Bus.$emit('toggle', this.collapsed)
      },
      // 显示修改密码弹窗
      handlePwd() {
        this.resetFormVisible = true;
      },
      // 关闭修改密码弹出框
      closeDialog() {
        this.resetFormVisible = false
      },
      // 修改密码
      chooseResetpwd(resetpwd) {
        var that = this;
        this.$refs[resetpwd].validate(valid => {
          if (valid) {
            // 判断两次密码是否一致
            if (that.resetpwd.password !== that.resetpwd.repassword) {
              that.$message.error('密码错误！')
              return;
            }
            // 请求方法
            userPwd(that.resetpwd)
              .then(res => {
                that.resetFormVisible = false
                that.loading = false
                if (res.statusCode == 200) {
                  that.$message({
                    type: 'success',
                    message: '修改密码成功！'
                  })
                  that.getdata(this.formInline)
                } else {
                  that.$message.error(res.message)
                }
              })
          } else {
            return false
          }
        })
      }
    }
  }
</script>
<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
  }

  .submenu {
    float: right;
  }

  .buttonimg {
    height: 60px;
    background-color: transparent;
    border: none;
  }

  .showimg {
    width: 26px;
    height: 26px;
    position: absolute;
    top: 17px;
    left: 17px;
  }

  .showimg:active {
    border: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue